import React, { Component } from 'react';

class RedirectPage extends Component {
      componentDidMount(){
      //   window.location.href = 'http://www.google.com';
        window.open('http://www.google.com');
      //   window.location.href('http://www.google.com');
      }
    }

export default RedirectPage;